import { cn } from '@/lib/utils';
import { PropsWithChildren, ReactElement } from 'react';

type VerticalCarouselProps<T = any> = PropsWithChildren<{
  pause?: boolean;
  direction?: 'up' | 'down';
  items: T[];
  renderItem: (item: T, ind: number, arr: T[]) => ReactElement;
  secondsPerItem?: number;
  classNames?: {
    container?: string;
    inner?: string;
  };
}>;

const VerticalCarousel = <T,>({
  items,
  renderItem,
  direction = 'up',
  secondsPerItem = 10,
  classNames,
}: VerticalCarouselProps<T>) => (
  <div className={cn(classNames?.container)}>
    {Array.from({ length: 2 }).map((_, index) => (
      <div
        key={index}
        style={{ animationDuration: `${secondsPerItem * items.length}s` }}
        className={cn(
          direction === 'up'
            ? 'animate-slide-bottom-top'
            : 'animate-slide-top-bottom',
          'grid',
          'infinite',
          classNames?.inner
        )}
      >
        {items.map(renderItem)}
      </div>
    ))}
  </div>
);

export default VerticalCarousel;
